import { AppData, Img, Lightning, Log, Registry, Router, Utils } from '@lightningjs/sdk'
import VideoResumeBar from './video-resume-bar'
import { Theme } from './info-ui'
import { AppSetup } from '../lib/app-setup'
import { Icon } from '@lightningjs/ui-components'
import { Helper } from '../lib/helper'
import FallbackImage from './fallback-image'

export interface ThumbItemTemplateSpec extends Lightning.Component.TemplateSpecLoose{
  ImageWrapper: object
  Image: object
  OverlayImage: object
  Fill: object
  imgTexture: any
}

export default class ThumbItem
  extends Lightning.Component<ThumbItemTemplateSpec>
  implements Lightning.Component<ThumbItemTemplateSpec>
{
  _theme: Theme = {};
  ImageWrapper = this.getByRef('ImageWrapper')!
  Image = this.getByRef('Image')!
  Fill = this.getByRef('Fill')!
  _imgTexture:any
  enterPressTime = new Date().getTime()
  isEnterPress = false;
  private _focusAnimation: Lightning.types.Animation | undefined = this.animation({
    duration: 0.4,
    actions: [
      { p: 'scale', v: { 0: 1, 1: 1.1 } },
      { t: 'Focus', p: 'alpha', v: { 0: 0, 1: 1 } },
    ],
  });

  static override _template(): Lightning.Component.Template<ThumbItemTemplateSpec> {
    return {
      collision:true,
      ImageWrapper: {
        x: 0,
        y: 0,
        w: (w) => w,
        h: (h) => h,
        rect: true,
        color: 0xff222222,
        Image: {},
        OverlayImage: {
          x: (w: number) => w - 10,
          y: (h: number) => h - 10,
          mountX: 1,
          mountY: 1,
          zIndex: 5,
          visible: false
        },
        VideoResumeBar: {
          x: 0,
          y: (h) => h - VIDEO_RESUME_BAR_HEIGHT,
          h: VIDEO_RESUME_BAR_HEIGHT,
          type: VideoResumeBar,
          item: this.bindProp("item"),
          zIndex: 1,
        },
        BlockItem : {
            w: (w) => w,
            h: (h) => h,
            rect:true,
            color: 0xAA222222,
            Icon: {
                mountX: 0.5,
                mountY: 0.5,
                // type: Icon,
                x: (w) => w / 2,
                y: (h: number) => h / 2,
                w: 60,
                h: 60,
                type: FallbackImage,
                imgSrc: 'images/ico-block.png',
            },
            zIndex: 3,
            visible:false,
            shader: {}
        },
        Focus: {
          x: (w) => w / 2,
          y: (h) => h / 2,
          w: (w) => w,
          h: (h) => h,
          alpha: 0,
          mount: 0.5,
          rect: true,
          color: 0x00000000,
          zIndex: 4,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 0,
            stroke: 6,
            strokeColor: 0xffffffff,
          }
        },
        
      },
    }
  }

  set imgTexture(_imgTexture) {
    this._imgTexture = _imgTexture
    this.patch({
      ImageWrapper: {
        Image: {
          //texture: Img(this.imgTexture.img).cover(this.imgTexture.w, this.imgTexture.h),
          x: this._imgTexture.w / 2,
          y: this._imgTexture.h / 2,
          alpha: 0.001,
          mount: 0.5,
          zIndex: this.core.findZContext().zIndex + 1,
          texture: {
            src: this._imgTexture.img,
            resizeMode: {
              h: this._imgTexture.h,
              type: 'cover',
              w: this._imgTexture.w
            },
            type: Lightning.textures.ImageTexture
          },
        }
      }
    })
    // this.patch({
    //   ImageWrapper: {
    //     Image: {
    //       texture: Img(imgTexture.img).cover(imgTexture.w, imgTexture.h),
    //     }
    //   }
    // })
    // this.patch({
    //   ItemTitle: {
    //     zIndex: this.core.findZContext().zIndex + 1,
    // }});
    this.updateOverlay();
  }

  updateOverlay() {
    if (!this.item || !this._imgTexture) return;
    const isPortrait = this._imgTexture.h > this._imgTexture.w;
    const overlayUrl = Helper.getOverlayUrl(this.item, isPortrait);
    if (overlayUrl !== '') {
      this.patch({
        ImageWrapper: {
          OverlayImage: {
            visible: true,
            w: this._imgTexture.w,
            h: this._imgTexture.h,
            x: 0,
            y: 0,
            mountX: 0,
            mountY: 0,
            texture: {
              src: overlayUrl,
              type: Lightning.textures.ImageTexture
            }
          }
        }
      });
    } else {
      this.patch({
        ImageWrapper: {
          OverlayImage: {
            visible: false
          }
        }
      });
    }
  }

  override _init() {
    const image = this.tag('Image')
    this.__ref = 'ThumbItem';

    const { appState } = AppData as AppSetup
    const app = appState?.getApp();
    this._theme = (app?.themesObj as Theme) || {};
    const appApiConfig = appState?.getAppApiConfig()
    this._theme.gridfocuscolor= `0xff${appApiConfig?.appLayoutConfig?.gridfocuscolor}` || '0xffffffff'

    image?.on('txLoaded', () => {
      image.setSmooth('alpha', 1)
    })
  
    this.updateOverlay();
    if (this.item.blockItem) {
      this.tag('BlockItem').visible = true;
    }
   

  }

  override _focus() {
    const { platform } = AppData as AppSetup
    platform?.textToSpeach(this.item.title)

    if (this._focusAnimation) {
      this._focusAnimation.start()
    }
    this._focusAnimation?.on('progress', () => {
      this.patch({
        ImageWrapper: {
          VideoResumeBar: {
            y: this.renderHeight - VIDEO_RESUME_BAR_HEIGHT - 4
          },
          Focus: {
            shader: {
              type: Lightning.shaders.RoundedRectangle,
              radius: 0,
              stroke: 6,
              strokeColor: this._theme.gridfocuscolor,
            }
          },
        }
      });
    })

    //this.tag("ImageWrapper.VideoResumeBar").setSmooth("y",this.renderHeight-VIDEO_RESUME_BAR_HEIGHT-8)
    this.fireAncestors('$onThumbFocused', this.item?.title || '')
  }

  override _handleEnter(e: KeyboardEvent): boolean | void {
    this.fireAncestors('$handleEnter')
  }

  override _unfocus() {
    this._focusAnimation?.stop()
    //this.tag("ImageWrapper.VideoResumeBar").setSmooth("y",this.renderHeight-VIDEO_RESUME_BAR_HEIGHT)
    this.patch({
      ImageWrapper: {
        VideoResumeBar: {
          y: this.renderHeight - VIDEO_RESUME_BAR_HEIGHT
        }
      }
    });
    this.fireAncestors('$onThumbFocused',  'Top Searches')
  }

  static get width() {
    return 400
  }

  static get height() {
    return 600
  }

  _handleClick(target) {
    // console.log('ItemBase _handleClick:', target, target.itemIndex, this.itemIndex)
    if(target.__ref == 'ThumbItem') {
      this.fireAncestors('$setHoverIndex', this.itemIndex)
      setTimeout(() => {
        this.fireAncestors('$handleEnter')
      }, 100)
    }
    // this._handleHover(target)
  }

  _handleHover(target) {
   // console.log('RowColumnGrid _handleHover:', target)
    this.fireAncestors('$setStateHover', 'SearchListThumbItem')
    target._focus()
  }

  _handleUnhover(target) {
   // console.log('RowColumnGrid _handleUnhover:', target.ref)
    target._unfocus()
  }

}
const VIDEO_RESUME_BAR_HEIGHT = 12;
